import React, {useState} from "react";
import {useElements, useStripe} from "@stripe/react-stripe-js";
import {ServerResponse} from "../../../models/models";
import {RESPONSE_TYPES} from "../../../constants";
import {getSubmitBtnText, loadResponsePage} from "../../../helpers/helpers";
import {SelectPaymentSection} from "../../common/checkout/SelectPaymentSection";
import {NewPaymentSection} from "../../common/checkout/NewPaymentSection";
import PlanSelectItemHeader from "../../common/subscriptions/PlanSelectItemHeader";

const CheckoutPage = (props: {
    selectedPlan: Object,
    payNow: boolean,
    isEligibleForFreeTrial: boolean,
    paymentIntentId: String,
    handleError: Function,
    setServerResponse: Function,
    setPage: Function,
    preferredPaymentMethodOrNull: Object,
    paymentType: number,
    pages: Object
}) => {
    const {
        data, selectedPlan, payNow, paymentIntentId,
        handleError, setServerResponse, isEligibleForFreeTrial, setPage,
        preferredPaymentMethodOrNull, paymentType, pages
    } = props;

    if (selectedPlan === null || !data) {
        return <></>;
    }

    const {allPaymentMethods, doNotRenew} = data;

    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(!payNow && allPaymentMethods.length === 0);
    const [selectedMethodId, setSelectedMethodId] = useState(preferredPaymentMethodOrNull);
    const [addNewMode, setAddNewMode] = useState(allPaymentMethods.length === 0);

    const handleStartFreeTrialResult = (result) => {
        setLoading(false);
        if (result.status !== 200) {
            console.error('Failed to start free trial');
            handleError(result, i18n.payments.error.genericServerError, setServerResponse);
            return;
        } else if (result.data.error !== null && result.data.error !== undefined) {
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data.error));
            return;
        }

        loadResponsePage('succeeded', setLoading, setServerResponse);
    };

    const handleSavePaymentDataResult = (result) => {
        setLoading(false);
        if (result.status !== 200) {
            console.error('Failed to save payment data');
            handleError(result, i18n.payments.error.genericServerError, setServerResponse);
            return;
        } else if (result.data.error !== null && result.data.error !== undefined) {
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data.error));
            return;
        }

        loadResponsePage('succeeded', setLoading, setServerResponse);
    };

    const submitBtnText = getSubmitBtnText(isEligibleForFreeTrial, payNow, doNotRenew);
    const planSelectLabel = `${selectedPlan?.label} ${selectedPlan.months === 1 ? `(${i18n.payments.monthly})` : `(${i18n.payments.annual})`}`

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <PlanSelectItemHeader selectedPlan={selectedPlan}
                                      planSelectLabel={planSelectLabel}
                                      doNotRenew={doNotRenew}
                                      isEligibleForFreeTrial={isEligibleForFreeTrial}
                                      payNow={payNow}/>

                <SelectPaymentSection type={paymentType}
                                      loading={loading}
                                      setLoading={setLoading}
                                      payNow={payNow}
                                      paymentIntentId={paymentIntentId}
                                      selectedPlan={selectedPlan}
                                      data={data}
                                      doNotRenew={doNotRenew}
                                      allPaymentMethods={allPaymentMethods}
                                      selectedMethodId={selectedMethodId}
                                      setSelectedMethodId={setSelectedMethodId}
                                      addNewMode={addNewMode}
                                      setAddNewMode={setAddNewMode}
                                      onBack={() => setPage(pages.PLAN_SELECT)}
                                      isEligibleForFreeTrial={isEligibleForFreeTrial}
                                      handleStartFreeTrialResult={handleStartFreeTrialResult}
                                      handleSavePaymentDataResult={handleSavePaymentDataResult}
                                      submitBtnText={submitBtnText}/>

                <NewPaymentSection type={paymentType}
                                   stripe={stripe}
                                   elements={elements}
                                   doNotRenew={doNotRenew}
                                   loading={loading}
                                   setLoading={setLoading}
                                   payNow={payNow}
                                   paymentIntentId={paymentIntentId}
                                   selectedPlan={selectedPlan}
                                   handleStartFreeTrialResult={handleStartFreeTrialResult}
                                   handleSavePaymentDataResult={handleSavePaymentDataResult}
                                   submitBtnText={submitBtnText}
                                   isEligibleForFreeTrial={isEligibleForFreeTrial}
                                   addNewMode={addNewMode}
                                   setAddNewMode={isEligibleForFreeTrial ? null : setAddNewMode}
                                   onBack={isEligibleForFreeTrial ? () => setPage(pages.PLAN_SELECT) : null}/>
            </div>
        </div>
    );
};

export default CheckoutPage;